<template>
    <footer id="footer" class="px-2 py-1">
        NextLevel by Semjuice©
        <a href="https://www.semjuice.com/mentions-legales" target="_blank">{{ $t('global.legalnotice') }}</a> /
        <a href="https://www.semjuice.com/contact" target="_blank">{{ $t('layout.contact') }}</a> /
        <a href="#" @click.prevent="toggleGTCModal()">{{ $t('layout.cgv') }}</a> /
        <a href="https://semjuice.com/p-faq#client-nextlevel" target="_blank">{{ $t('layout.faqcustommers') }}</a> /
        <a href="https://semjuice.com/p-faq#editeurs-nextlevel" target="_blank">{{ $t('layout.faqpartners') }}</a>
    </footer>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        name: 'AppFooter',
        data() {
            return {}
        },
        methods: {
            ...mapMutations(['toggleGTCModal']),
            openMentions: function () {
                this.$refs.mentionsModal.show()
            },
            closeMentions: function () {
                this.$refs.mentionsModal.hide()
            }
        }
    }
</script>

